<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_partner_role"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="true"
        @on-add="showFormModalDialog"
      />
      <RoleFormDialog
        :id="entityId"
        :visible="modalForm"
        :width="400"
        :action="url"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
import RoleFormDialog from './role-details'
export default {
  name: 'PartnerRoleList',
  components: { TableWrapper, RoleFormDialog },
  data() {
    return {
      url: this.$config.apiContextPath + '/partner/type',
      modalForm: false,
      entityId: 0,
      modCount: 0
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '角色名', placeholder: '请输入角色名...', name: 'name', width: 'auto', type: 'input' },
          { label: '角色代号', placeholder: '请输入角色代号...', name: 'code', width: 'auto', type: 'input' }
        ]
      }
    },
    // mockData() {
    //   return [
    //     {
    //       id: 1, // 合伙人类型id
    //       name: '分成合伙人', // 合伙人类型名称
    //       code: 'partner_shared', // 合伙人类型code
    //       // deposit: 2000, // 押金 (deprecated)
    //       // rate: 0.2, // 提成比例 (deprecated)
    //       createTime: '2020-04-05 22:24', // 创建时间
    //       updateTime: '2020-04-25 23:01' // 更新时间
    //     },
    //     { name: '授权合伙人', code: 'partner_authorized', deposit: 0, rate: 0.2, createTime: '2020-04-05 22:24', updateTime: '2020-04-25 23:01' }
    //   ]
    // },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '角色名', align: 'left', key: 'name', sortable: true, ellipsis: true, tooltip: true },
        { title: '角色代号', align: 'left', key: 'code', sortable: true, ellipsis: true, tooltip: true },
        // { title: '保证金', align: 'center', key: 'deposit', sortable: true, ellipsis: true, tooltip: true },
        // { title: '提成比例', align: 'center', key: 'rate', sortable: true, ellipsis: true, tooltip: true },
        { title: '创建时间', align: 'center', sortable: true, key: 'createTime', ellipsis: true, tooltip: true },
        { title: '更新时间', align: 'center', sortable: true, key: 'updateTime', ellipsis: true, tooltip: true },
        { title: '操作', align: 'center', width: 180, key: '_actions', disabled: true,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ])
            ])
          }
        }
      ]
    }
  },
  methods: {
    onModalClose(changed) {
      this.entityId = 0
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    showFormModalDialog(id = '') {
      this.modalForm = true
      this.entityId = id ? parseInt(id) : 0
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除合伙人类型么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '合伙人类型 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '合伙人类型 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    }
  }
}
</script>
